import { render } from "./CartOrddet.vue?vue&type=template&id=60d1ebfc&scoped=true"
import script from "./CartOrddet.vue?vue&type=script&lang=js"
export * from "./CartOrddet.vue?vue&type=script&lang=js"

import "./CartOrddet.vue?vue&type=style&index=0&id=60d1ebfc&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d1ebfc"]])

export default __exports__